if (typeof window.i18nJSON !== 'undefined' && window.i18nJSON) {
  _.setTranslation(window.i18nJSON);
} else {
  console.log('window.i18nJSON is not available. Translation of JavaScript strings will fail.');
}
